import { MessageSquareOff } from 'lucide-react';

import { useSearchParam } from '@/helpers/url';

import ConversationPreviewRow from './ConversationPreviewRow';

import Loader from '@/components/common/Loader';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import { useConversations } from '@/data/conversation';

const BookingConversations = () => {
  const conversationType = useSearchParam('type');
  const searchQuery = useSearchParam('q');
  const conversations = useConversations({
    type: conversationType,
    q: searchQuery
  });

  if (conversations.isLoading && !conversations.data) {
    return (
      <div className="flex justify-center items-center h-[240px]">
        <Loader />
      </div>
    );
  }

  if (conversations.data.length === 0) {
    return (
      <div className="flex justify-center items-center h-[240px]">
        <Empty>
          <EmptyIcon>
            <MessageSquareOff />
          </EmptyIcon>
          <EmptyTitle>No Conversations Found</EmptyTitle>
          <EmptyDescription>
            Book a Pro to start a booking conversation
          </EmptyDescription>
        </Empty>
      </div>
    );
  }

  return (
    <div className="flex-grow overflow-y-auto">
      <ul className="divide-y">
        {conversations.data.map((conversation) => (
          <ConversationPreviewRow
            conversation={conversation}
            key={conversation.id}
          />
        ))}
      </ul>
    </div>
  );
};

export default BookingConversations;
